import {Component} from 'react';
import h from 'react-hyperscript';
import './SurveyMessaging.scss';
import {h4, p} from 'Components/Typography/Typography';
import Button from 'Components/Buttons/Buttons';
import ShareLink from 'Components/ShareLink/ShareLink';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import {googleCalendarUrl} from 'Src/utils/utils';
import UpdateProductWindow from '../../UpdateProductWindow/UpdateProductWindow';

class SurveyMessaging extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyTitle: '',
      endDate: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.surveyTitle !== prevProps.surveyTitle) {
      this.setSurveyTitle(this.props.surveyTitle);
    }
  }

  setSurveyTitle(value) {
    this.setState({
      surveyTitle: value,
    });
  }

  createCtas() {
    const ctas = this.props.ctas.map((cta, i) => {
      if (cta.type === 'share-link-survey') {
        if (this.props.userStatus.admin_level !== 'Admin') {
          return null;
        }
        const slug = cta.title.replace(' ', '-').toLowerCase();
        return h(
            ShareLink,
            {
              id: `share-link-button--${i}`,
              slug: slug,
              shareUrl: this.props.shareUrl,
            },
            null
        );
      } else if (cta.type === 'share-link-report') {
        if (this.props.userStatus.admin_level !== 'Admin') {
          return null;
        }
        const slug = cta.title.replace(' ', '-').toLowerCase();
        return h(
            ShareLink,
            {
              id: `share-link-button--${i}`,
              slug: slug,
              message: cta.title,
              // eslint-disable-next-line max-len
              shareUrl: `${window.location.host}/app/districts/${this.props.districtId}/reports/${this.props.latestReport.report_card_name
                  .toLowerCase()
                  .replace(' ', '-')}?${
                this.props.latestReport.district_report_card_id
              }`,
            },
            null
        );
      } else if (cta.type === 'update-product-window') {
        if (this.props.userStatus.admin_level !== 'Admin') {
          return null;
        }
        return h(UpdateProductWindow, {
          googleUser: this.props.googleUser,
          csrf: this.props.csrf,
          idToken: this.props.idToken,
          userStatus: this.props.userStatus,
          setProductWindowsLoading: this.props.setProductWindowsLoading,
        });
      } else if (cta.type === 'remind-me') {
        return h(
            Button,
            {
              key: `survey-messaging-cta--${i}`,
              type: 'inline',
              external: true,
              to: googleCalendarUrl({
                title: cta.title,
                desc: cta.desc,
                date: new Date(this.props.date.replace(/-/g, '/'))
                    .toISOString()
                    .replace(/-|:|\.\d\d\d/g, ''),
              }),
              className: 'margin-right--sm',
            },
            [
              h(
                  'span',
                  {
                    className: 'material-icons padding-right--micro',
                  },
                  'calendar_today'
              ),
              cta.label,
            ]
        );
      } else if (cta.type === 'report') {
        const classes = (this.props.missingData ?
                        'inactive' : 'margin-right--sm');
        return h(
            Button,
            {
              key: `survey-messaging-cta--${i}`,
              type: 'basic',
              // eslint-disable-next-line max-len
              to: `/app/districts/${this.props.districtId}/reports/${this.props.latestReport.report_card_name
                  .toLowerCase()
                  .replace(' ', '-')}?${
                this.props.latestReport.district_report_card_id
              }`,
              className: classes,
              icon: '/assets/icons/chart.svg',
            },
            cta.title
        );
      } else if (cta.type === 'survey') {
        return h(
            Button,
            {
              key: `survey-messaging-cta--${i}`,
              type: 'grey',
              to: `/app/survey/${this.props.shareUrl.split('/').pop()}`,
              className: 'survey-message-cta',
              onClick: this.props.onSurveyClick,
              icon: '/assets/icons/survey.svg',
            },
            cta.title
        );
      } else {
        return h(
            Button,
            {
              key: `survey-messaging-cta--${i}`,
              type: cta.type,
              to: cta.href,
              className: 'survey-message-cta',
              onClick: this.props.onSurveyClick,
            },
            cta.title
        );
      }
    });
    return ctas;
  }

  render() {
    const reportMissingDataNotFound = this.props.reportMissingDataNotFound;
    const reportMissingDataMsg = this.props.reportMissingDataMsg;
    const loading = this.props.loading;
    const subtitle = this.props.subtitle;
    const subText = this.props.shareMessage || subtitle;
    const SubtitleComponent = this.props.SubtitleComponent;
    const showCtas = this.props.ctas && !loading && !reportMissingDataNotFound;
    const shareInfo = this.props.shareInfo;
    let borderRight = this.props.borderRight;
    borderRight = typeof borderRight === 'boolean' ? borderRight : true;

    return h(
        'div',
        {
          className: `survey-messaging__container col-ratio-3${
          borderRight ? ' border--right' : ''
          }`,
        },
        [
          h(
              h4,
              {
                id: 'survey-messaging__title',
                key: `survey-messaging__title`,
                className: 'survey-messaging__title',
              },
              `${this.props.title}`
          ),
        SubtitleComponent ? SubtitleComponent : null,
        subText && !SubtitleComponent ?
          h(
              p,
              {
                key: `survey-messaging-share`,
                className: 'text--grey survey-messaging__subtitle',
              },
              subText
          ) :
          null,
        loading ? h(LoadingIndicator, null, null) : null,
        reportMissingDataMsg ?
          h(
              p,
              {
                key: `survey-messaging-report`,
                className: 'text--grey survey-message__report',
              },
              reportMissingDataMsg
          ) :
          null,
        showCtas ?
          h(
              'div',
              {
                key: 'survey-messaging-ctas',
                className: 'flex flex--wrap',
              },
              this.createCtas()
          ) : null,
        shareInfo && h(
            p,
            {
              key: 'survey-info-text',
              className: 'text--grey padding-top--sm',
              dangerouslySetInnerHTML: shareInfo,
            }
        )],
    );
  }
}

export default SurveyMessaging;
